/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CreateParameterCombinationTableDto } from './CreateParameterCombinationTableDto';
import {
    instanceOfCreateParameterCombinationTableDto,
    CreateParameterCombinationTableDtoFromJSON,
    CreateParameterCombinationTableDtoFromJSONTyped,
    CreateParameterCombinationTableDtoToJSON,
} from './CreateParameterCombinationTableDto';

/**
 * @type GetCombinationTableDtoPreviousTable
 * 
 * @export
 */
export type GetCombinationTableDtoPreviousTable = CreateParameterCombinationTableDto;


export function GetCombinationTableDtoPreviousTableFromJSON(json: any): GetCombinationTableDtoPreviousTable {
    return GetCombinationTableDtoPreviousTableFromJSONTyped(json, false);
}

export function GetCombinationTableDtoPreviousTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCombinationTableDtoPreviousTable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...CreateParameterCombinationTableDtoFromJSONTyped(json, true) };
    return  CreateParameterCombinationTableDtoFromJSONTyped(json, true);
}

export function GetCombinationTableDtoPreviousTableToJSON(value?: GetCombinationTableDtoPreviousTable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfCreateParameterCombinationTableDto(value)) {
        return CreateParameterCombinationTableDtoToJSON(value as CreateParameterCombinationTableDto);
    }

    return {};
}

/**
 * Check if a given object implements the GetCombinationTableDtoPreviousTable interface.
 */
export function instanceOfGetCombinationTableDtoPreviousTable(value: any): value is GetCombinationTableDtoPreviousTable {
    if (instanceOfCreateParameterCombinationTableDto(value)) return true;
    return false;
}

